// components/Footer.js
import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-container">
          <div className="footer-brand">
            <div className="footer-logo">
              <div className="cinder-diamond">
                <div className="diamond-inner"></div>
              </div>
              <span className="logo-text">Cinder</span>
            </div>
            <p className="footer-tagline">
              Machine learning model analysis toolkit for PyTorch, TensorFlow, and scikit-learn
            </p>
          </div>
          
          <div className="footer-links">
            <div className="footer-links-column">
              <h4>Documentation</h4>
              <ul>
                <li><a href="#documentation">Getting Started</a></li>
                <li><a href="#documentation">API Reference</a></li>
                <li><a href="#documentation">Examples</a></li>
              </ul>
            </div>
            
            <div className="footer-links-column">
              <h4>Features</h4>
              <ul>
                <li><a href="#features">Performance Metrics</a></li>
                <li><a href="#features">Error Analysis</a></li>
                <li><a href="#features">Feature Importance</a></li>
              </ul>
            </div>
            
            <div className="footer-links-column">
              <h4>Frameworks</h4>
              <ul>
                <li><a href="#frameworks">PyTorch</a></li>
                <li><a href="#frameworks">TensorFlow</a></li>
                <li><a href="#frameworks">scikit-learn</a></li>
              </ul>
            </div>
            
            <div className="footer-links-column">
              <h4>Contact</h4>
              <ul>
                <li><a href="mailto:support@example.com">Support</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="footer-container">
          <p className="copyright">© 2025 Cinder. All rights reserved.</p>
          <div className="footer-legal">
            <a href="#terms">Terms of Service</a>
            <a href="#privacy">Privacy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;